module.exports = __webpack_public_path__ + "img/twitter.a71e96d7.svg";